import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"c-avalanche\">\n  {{yield}}\n</div>",{ moduleName: "mewe/pods/components/cms/routable/avalanche/template.hbs" })